module.exports = __webpack_public_path__ + "img/633ec66.png";